















import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import CreateSessionResultModel from "@/models/security/zorgID/createSessionResultModel";

@Component
export default class InitializeSessionComponent extends Vue {
  @Prop() private enableUI!: boolean;

  private createSessionResultModel = new CreateSessionResultModel();

  private btnLogonEnabled: boolean = false;

  private isSessionInitialized: boolean = false;

  private created() {
    this.subscribeToEvents();
  }

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSessionInitializedReceived(x => {
      me.sessionInitialized(x);
    });
  }

  public initializeSession() {
    var me = this;
    me.isSessionInitialized = false;
    me.btnLogonEnabled = false;
    me.createSessionResultModel = new CreateSessionResultModel();

    SecurityService.getInstance().initializeSession();
  }

  private sessionInitialized(model: CreateSessionResultModel) {
    var me = this;
    me.createSessionResultModel = model;
    me.btnLogonEnabled = true;
    me.isSessionInitialized = true;

    if (!me.enableUI) {
      me.logon();
    }
  }

  private logon() {
    var me = this;
    me.btnLogonEnabled = false;
    me.$emit("sessionInitialized", me.createSessionResultModel);
  }
}
